import { useCallback, useEffect, useRef, useState } from 'react';
export var useHover = function (fallbackToClickFunctionality) {
    var _a = useState(false), isBeingHovered = _a[0], setIsBeingHovered = _a[1];
    var ref = useRef(null);
    var _handleMouseEnter = useCallback(function () { return setIsBeingHovered(true); }, []);
    var _handleMouseLeave = useCallback(function () { return setIsBeingHovered(false); }, []);
    var _handleClick = useCallback(function () { return setIsBeingHovered(function (isBeingHovered) { return !isBeingHovered; }); }, []);
    useEffect(function () {
        var node = ref.current;
        if (node) {
            node.addEventListener('mouseenter', _handleMouseEnter);
            node.addEventListener('mouseleave', _handleMouseLeave);
            if (fallbackToClickFunctionality) {
                node.addEventListener('click', _handleClick);
            }
            return function () {
                node.removeEventListener('mouseenter', _handleMouseEnter);
                node.removeEventListener('mouseleave', _handleMouseLeave);
                if (fallbackToClickFunctionality) {
                    node.removeEventListener('click', _handleClick);
                }
            };
        }
    }, [_handleMouseEnter, _handleMouseLeave, _handleClick, fallbackToClickFunctionality]);
    return [ref, isBeingHovered];
};
